import React, {useContext} from "react";
import {EditContext} from "../../../../misc/scroller/EditProvider";
import {blue, grey, orange} from "@mui/material/colors";
import {editCellPadding} from "../../../../misc/scroller/TableEditCell";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import {IndeterminateCheckBox} from "@mui/icons-material";

export function CheckColumn<T>(props: {
    value: T;
    onChange(value: T, tf: boolean): void;
    getValue(value: T): boolean | null;
}) {
    const sel = useContext(EditContext);
    const selected = props.getValue(props.value)

    return (
        <div
            style={{
                width: "100%", display: "flex", justifyContent: "center",
                fontSize: "0.9rem", cursor: "pointer",
                color: selected === true ? blue["600"] : selected === null ? orange["300"] : grey["300"],
                borderRadius: 5,
                position: "relative",
                marginLeft: -editCellPadding.left,
                marginRight: -editCellPadding.right,
                marginTop: -editCellPadding.top - 2,
                marginBottom: -editCellPadding.bottom - 2,
                height: 22,
                overflow: "hidden",
            }}
        >
            {/* This div is used to capture mouse events */}
            <div
                style={{
                    position: "absolute",
                    top: 0, left: 0, right: 0, bottom: 0,
                }}
                onClick={() => {
                    const obj = Object.assign({}, props.value);
                    props.onChange(obj, !props.getValue(obj))
                    sel.update(obj)
                }}
            ></div>
            {selected === true ? <CheckBoxIcon /> : selected === null ? <IndeterminateCheckBox /> : <CheckBoxOutlineBlankIcon />}
        </div>
    )
}


export function CheckColumn2(props: {
    value: boolean;
    onClick(): void;
}) {
    const selected = props.value

    return (
        <div
            style={{
                width: "100%", display: "flex", justifyContent: "center",
                fontSize: "0.9rem", cursor: "pointer",
                color: selected ? blue["600"] : grey["300"],
                borderRadius: 5,
                position: "relative",
                marginLeft: -editCellPadding.left,
                marginRight: -editCellPadding.right,
                marginTop: -editCellPadding.top - 2,
                marginBottom: -editCellPadding.bottom - 2,
                height: 22,
                overflow: "hidden",
            }}
        >
            {/* This div is used to capture mouse events */}
            <div
                style={{
                    position: "absolute",
                    top: 0, left: 0, right: 0, bottom: 0,
                }}
                onClick={props.onClick}
            ></div>
            {selected ? <CheckBoxIcon /> : <CheckBoxOutlineBlankIcon />}
        </div>
    )
}
